import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    activity: 'Activity',
    address: 'Address',
    capital: 'Company capital amount (€)',
    description: 'This information should match what’s written on your Kbis.',
    employees: 'Number of employees',
    financialInformation: 'Financial data',
    identity: 'Company identity',
    legalInformation: 'Legal information',
    legalName: 'Legal Name',
    nafCode: 'NAF / APE Code',
    registrationDate: 'Registration date',
    siret: 'SIRET',
    title: 'Confirm your company information',
    tradeName: 'Trade Name (optional)',
    turnover: 'Annual turnover (€)',
    validate: 'Confirm',
  },
  fr: {
    activity: 'Activité',
    address: 'Adresse',
    capital: 'Montant du capital social de la société (€)',
    description:
      'Ces informations doivent correspondre à celles qui sont indiquées sur votre Kbis.',
    employees: 'Nombre de salarié•e•s',
    financialInformation: 'Données financières',
    identity: 'Identité de l’entreprise',
    legalInformation: 'Informations juridiques',
    legalName: 'Nom légal',
    nafCode: 'Code NAF / APE',
    registrationDate: 'Date de création',
    siret: 'SIRET',
    title: 'Confirmez les informations de votre entreprise',
    tradeName: 'Nom commercial (optionnel)',
    turnover: 'Chiffre d’affaire annuel (€)',
    validate: 'Confirmer mes informations',
  },
} as const);

export default locales;
